async function devtricker_ajax_isPostInReadingList(postId) {
    try {
        const formData = new FormData();

        formData.append('action', 'devtricker_action_is_in_reading_list_ajax');
        formData.append('nonce', await devtricker_process_getDevtrickerNonce);
        formData.append('post_id', postId);

        const response = fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {

            devtricker_log(null, devtricker_log_level.INFO, `AJAX - Checked if a post is in reading list.`);

            result.data.is_in_reading_list;

        } else {
            throw new Error(result.data.message);
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'AJAX - Error when try to check if post is in reading list.');
        throw error;
    }
}

async function devtricker_ajax_getUserLikedPosts(userId, page, nonce) {
    try {
        const url = `/wp-admin/admin-ajax.php?action=devtricker_post_like_action_get_liked_posts_ajax&user_id=${userId}&page=${page}&nonce=${nonce}`;
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, `User posts like successfully retrieved - AJAX - Page: ${page}`);
            return  {
                likedPosts: result.data.liked_posts,
                hasNext: response.headers.get('X-Has-Next') === 'true'
            };
        
        } else {
            throw new Error(result.data.message);
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_toggleReadingList(postId, action) {
    if (!devtricker_getTheLoggedUserId()) return;

    try {
        const formData = new FormData();

        formData.append('action', 'devtricker_action_toggle_reading_list_ajax');
        formData.append('nonce', await devtricker_process_getDevtrickerNonce());
        formData.append('post_id', postId);
        formData.append('reading_action', action);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, result.data.message);
        } else {
            throw new Error(result.data.message);
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_checkIfPostIsInReadingList(postId) {
    const userId = devtricker_getTheLoggedUserId();

    if (!userId) return;

    try {
        const url = `/wp-admin/admin-ajax.php?action=devtricker_action_check_reading_list_ajax&post_id=${postId}&user_id=${userId}`;

        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, `Reading list status for post ${postId} retrieved successfully.`);
            return result.data.added === true;
        } else {
            throw new Error(result.data.message);
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}